// ============ API URL Helper ============
export const getBaseURL = () => {
    const url = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const cleanUrl = url.replace(/\/$/, '');
    if (cleanUrl.endsWith('/api')) {
      return cleanUrl;
    }
    return `${cleanUrl}/api`;
  };
  
  export const API_URL = getBaseURL();